import React from "react";
import { faChevronRight } from "@fortawesome/pro-regular-svg-icons";
import { Optional } from "@singlestore/fusion/utils/types";

import { LinkButton } from "components/Button/LinkButton";
import { FaIcon } from "components/FaIcon/FaIcon";

export function SignInButton({
    to = "https://portal.singlestore.com/",
    target = "_blank",
    rel = "noreferrer",
    ...rest
}: Optional<React.ComponentProps<typeof LinkButton>, "to">) {
    return (
        <LinkButton
            to={to}
            target={target}
            rel={rel}
            variation="secondary"
            size="md"
            {...rest}
        >
            Sign in
        </LinkButton>
    );
}

export function TryFreeButton({
    to = "https://www.singlestore.com/cloud-trial/",
    target = "_blank",
    rel = "noreferrer",
    iconRight = <FaIcon icon={faChevronRight} />,
    ...rest
}: Optional<React.ComponentProps<typeof LinkButton>, "to">) {
    return (
        <LinkButton
            to={to}
            target={target}
            rel={rel}
            iconRight={iconRight}
            variation="primary"
            size="md"
            {...rest}
        >
            Try Free
        </LinkButton>
    );
}
